export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const PAGING_INFO = 'PAGING_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';

export default {
	// ...common,
	SEARCH_PARAM,
	STATE_INIT,
	PAGING_INFO,
	DEFAULT_ASSIGN
};
